import React, { Component } from 'react';
import FetchService from '../../services/FetchService.js';
import AuthService from '../../services/AuthService.js';
import { BuscadorEmpleadoControl } from '../Controls/BuscadorEmpleado/BuscadorEmpleadoControl';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
registerLocale('es', es);


export class CalendarioContentPanel extends Component {
    constructor(props) {
        super(props);
        let empleadoId = -1;
        if (AuthService.getToken().auxId) {
            empleadoId = AuthService.getToken().auxId;
        }
        this.state = {
            controls: [],
            empleadoId: empleadoId,
            fecha: new Date()
        }
        this.mensaje = "No hay programación.";

        this.initDatePicker();

        this.datePicker_onChange = this.datePicker_onChange.bind(this);
        this.buscador_onEmpleadoSeleccionado = this.buscador_onEmpleadoSeleccionado.bind(this);
    }
    initDatePicker() {
        const monthsBG = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        const daysBG = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
        registerLocale('bg', {
            localize: {
                month: n => monthsBG[n],
                day: n => daysBG[n]
            },
            formatLong: {}
        });
    }
    datePicker_onChange(e) {
        var me = this;
        this.cargarProgramacion(this.state.empleadoId, e);
    }
    buscador_onEmpleadoSeleccionado(e) {
        var me = this;
        this.cargarProgramacion(e, this.state.fecha);
    }
    componentWillMount() {
        var me = this;
        this.cargarProgramacion(this.state.empleadoId, this.state.fecha);
    }
    cargarProgramacion(empleadoId, fecha) {
        var me = this;
        this.mensaje = "Cargando...";
        this.setState({
            controls: [],
            empleadoId: empleadoId,
            fecha: fecha
        });

        this.forceUpdate();

        var d = fecha;
        var sfi = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
        var sff = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59";

        var url = 'api/Calendario/CargarProgramacion?id=' + empleadoId + '&fechaInicial=' + sfi + '&fechaFinal=' + sff;
        FetchService.send(url, 'GET', null, me.programacionCargada.bind(me), me.programacionCargadaError.bind(me));

    }
    programacionCargada(registros) {
        var me = this;
        this.mensaje = "No hay programación.";
        var controls = [];
        controls.push(this.crearListado(registros))
        this.setState({
            controls: controls, 
        });
        me.forceUpdate();
    }
    crearListado(registros) {
        var f = this.state.fecha.toLocaleDateString();
        var l = [];
        if (registros) {
            for (var i = 0; i < registros.length; i++) {
                var r = registros[i];
                l.push(this.crearItem(r));
            }
        }
        if (l.length == 0) {
            l.push(
                <div class="alert alert-warning" role="alert">
                    <div><b>{this.mensaje}</b></div>
                </div>
            );
        }
        return <div>
            <div>{l}</div>
        </div>

    }
    crearItem(registro) {
        let fi = new Date(registro.fechaInicial);
        let ff = new Date(registro.fechaFinal);

        let cls = "alert alert-primary";
        switch (registro.tipo) {
            case "Turno": cls = "alert alert-success"; break;
            case "Ausencia": cls = "alert alert-warning"; break;
        }

        return <div class={cls} role="alert">
            <div><b>{registro.descripcion}</b></div>
            <div>Inicio: {fi.toLocaleString()}</div>
            <div>Fin: {ff.toLocaleString()}</div>
            <div><b>{registro.centroCosto}</b></div>
        </div>
    }
    crearBuscadorEmpleado() {
        var e = AuthService.getToken().auxId
        if (!e) {
            return <BuscadorEmpleadoControl onEmpleadoSeleccionado={this.buscador_onEmpleadoSeleccionado} />
        }
    }
    programacionCargadaError(err) {
        var me = this;
        alert(err);
    }
    crearCalendario() {
        var me = this;
        return me.state.controls;
    }
    render() {
        return (
            <div>
                <div>
                    {this.crearBuscadorEmpleado()}
                </div>
                <div class="form-group">
                    <div class="form-row">
                        <div class="col-md-12">
                            <DatePicker className="form-control col-md-12" placeholderText="Seleccionar fecha..." showPopperArrow={false} selected={this.state.fecha} onChange={this.datePicker_onChange} locale="es" dateFormat="dd/MM/yyyy" />
                        </div>
                    </div>
                </div>
                <br />
                <div>
                    {this.crearCalendario()}
                </div>
            </div>
        );
    }
}

